import { Link, useLocation } from "react-router";

import ArtObjectsHeader from "./ArtObjectsHeader";
import styles from "./ArtObjectsList.module.scss";

const getArtWarehouseScrollStorageKey = (search) =>
  `art-warehouse-scroll:${search || ""}`;

const ArtObjectsList = ({ objects = [], sortKey, sortDirection, onSort }) => {
  const location = useLocation();
  const handleOpenObject = () => {
    sessionStorage.setItem(
      getArtWarehouseScrollStorageKey(location.search),
      String(window.scrollY)
    );
  };

  return (
    <ul className={styles.cardList}>
      <li>
        <ArtObjectsHeader
          sortKey={sortKey}
          sortDirection={sortDirection}
          onSort={onSort}
        />
      </li>
      {objects.length === 0 ? (
        <li className={styles.empty}>No objects found.</li>
      ) : (
        objects.map((obj) => (
          <li key={obj.objectId}>
            <Link
              to={`/art-warehouse/${obj.objectId}`}
              state={{ object: obj, fromSearch: location.search }}
              className={styles.cardLink}
              onClick={handleOpenObject}
            >
              <article className={styles.cardRow}>
                <div className={styles.left}>
                  <span className={styles.infoContainer}>
                    <span className={styles.cardLabel}>Warehouse</span>
                    {obj.warehouseName ? (
                      <span className={styles.warehouseBadge}>
                        {obj.warehouseName}
                      </span>
                    ) : (
                      <span className={styles.muted}>None</span>
                    )}
                  </span>
                  <span className={styles.infoContainer}>
                    <span className={styles.cardLabel}>Type</span>
                    <span
                      className={
                        obj.type === "Container"
                          ? styles.containerTypeText
                          : styles.typeText
                      }
                    >
                      {obj.type === "Container" ? "Container" : obj.type}
                    </span>
                  </span>
                  <span className={styles.infoContainer}>
                    <span className={styles.cardLabel}>MTAB Serial</span>
                    <span
                      className={
                        obj.serialNumber ? styles.cardValue : styles.muted
                      }
                    >
                      {obj.serialNumber || "None"}
                    </span>
                  </span>
                  <span className={styles.infoContainer}>
                    <span className={styles.cardLabel}>Inv. No</span>
                    <span className={styles.cardValues}>
                      <span
                        className={
                          obj.inventoryNo ? styles.cardValue : styles.muted
                        }
                      >
                        {obj.inventoryNo || "None"}
                      </span>
                    </span>
                  </span>
                </div>

                <div className={styles.right}>
                  <span className={styles.infoContainer}>
                    <span className={styles.cardLabel}>Title</span>
                    <span
                      className={
                        obj.artworkTitle
                          ? `${styles.cardValue} ${styles.cardItalic}`
                          : obj.containerTitle
                            ? styles.cardValue
                            : styles.muted
                      }
                    >
                      {obj.artworkTitle || obj.containerTitle || "None"}
                    </span>
                  </span>
                  <span className={styles.infoContainer}>
                    <span className={styles.cardLabel}>Artist</span>
                    <span
                      className={obj.artist ? styles.cardValue : styles.muted}
                    >
                      {obj.artist || "None"}
                    </span>
                  </span>
                  <span className={styles.infoContainer}>
                    <span className={styles.cardLabel}>Type of art</span>
                    <span
                      className={
                        obj.typeOfArt ? styles.cardValue : styles.muted
                      }
                    >
                      {obj.typeOfArt || "None"}
                    </span>
                  </span>
                  <span className={styles.infoContainer}>
                    <span className={styles.cardLabel}>Date in</span>
                    <span
                      className={
                        obj.orderInDate ? styles.cardValue : styles.muted
                      }
                    >
                      {obj.orderInDate || "None"}
                    </span>
                  </span>
                </div>
              </article>
            </Link>
          </li>
        ))
      )}
    </ul>
  );
};

export default ArtObjectsList;
